import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { useQuery } from '@tanstack/react-query';

export const VERIFIED_TRADING_PARTNER_QUERY_KEY =
  'VERIFIED_TRADING_PARTNER_QUERY_KEY';

const useReadOneIsAs2ActiveById = (verifiedTradingPartnerId?: number) =>
  useQuery({
    enabled: Boolean(verifiedTradingPartnerId),
    queryKey: [
      VERIFIED_TRADING_PARTNER_QUERY_KEY,
      endpoints.verifiedTradingPartner.read.one.isAs2Active.by.id(),
      verifiedTradingPartnerId,
    ],
    queryFn: () =>
      api.verifiedTradingPartner.read.one.isAs2Active.by.id(
        verifiedTradingPartnerId || 0
      ),
  });

const verifiedTradingPartnerQueryHooks = {
  useReadOneIsAs2ActiveById,
};

export default verifiedTradingPartnerQueryHooks;
